module.exports = __webpack_public_path__ + "static/logo-e65237dc203948138988bfcc547972ec.png";